// Normaliza texto para buscar sin distinguir mayusculas ni tildes
// ("Sofía" == "sofia"). Quita las marcas combinadas (U+0300 a U+036F).
export function normalizarTexto(valor) {
  return String(valor ?? '')
    .normalize('NFD')
    .split('')
    .filter((ch) => {
      const c = ch.charCodeAt(0);
      return c < 768 || c > 879;
    })
    .join('')
    .toLowerCase();
}
